import type { SWRConfiguration } from "swr";
import { ApiContractViolationError } from "./pictureRequestContract";

// SWR の errorRetryInterval 既定値（ミリ秒）。SWRConfig の外で描画された場合の保険
const DEFAULT_ERROR_RETRY_INTERVAL_MS = 5000;

/**
 * 応答契約違反だけ再試行を止める SWR の onErrorRetry。
 *
 * 契約違反は取り直しても結果が変わらない（通知・リクエストが倍増するだけ）ため再試行しない。
 * ネットワーク断や5xxなど一過性の失敗は SWR 既定と同じ判定・間隔（指数バックオフ）で再試行する。
 * `shouldRetryOnError: false` で全再試行を止めると、SWR 2.2 の refreshInterval はキャッシュにエラーが
 * 残っている間は再取得をスキップするため、一度のエラーでポーリングが復旧しなくなる。
 * retryCount は1始まり。errorRetryCount 未設定なら回数無制限だが指数バックオフで間隔が伸びる。
 */
export const retryUnlessContractViolation: NonNullable<
  SWRConfiguration["onErrorRetry"]
> = (error, _key, config, revalidate, { retryCount }) => {
  if (error instanceof ApiContractViolationError) return;
  const maxRetryCount = config.errorRetryCount;
  if (maxRetryCount !== undefined && retryCount > maxRetryCount) return;
  // 未設定と 0 は既定値に置き換える（0 のまま使うと間隔なしの連続再試行になる）
  const interval =
    config.errorRetryInterval !== undefined && config.errorRetryInterval > 0
      ? config.errorRetryInterval
      : DEFAULT_ERROR_RETRY_INTERVAL_MS;
  const backoff =
    ~~((Math.random() + 0.5) * (1 << Math.min(retryCount, 8))) * interval;
  setTimeout(() => {
    void revalidate({ retryCount });
  }, backoff);
};
